import React from 'react';
import { __, sprintf } from '@wordpress/i18n';

// store
import { useStoreValue } from '../../../../../../store';

// components
import StatusIconComponent from '../../../../../../components/StatusIconComponent';

const UserStatusTopBar = () => {
    const userData = useStoreValue('userData');
    const fullName = `${userData?.name ?? ''} ${userData?.surname ?? ''}`;

    if (!userData?.name) {
        return null;
    }

    return(
        <div className="userStatusTopBar">
            <StatusIconComponent status="In Progress"></StatusIconComponent>
            <span className="userStatusTopBar__text">
                {sprintf(__('Benvenuto %s!', 'soundbetween'), fullName)}
            </span>
        </div>
    )
}

export default UserStatusTopBar;